import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// import
import { useState, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useApolloNetworkStatus } from '@meepshop/apollo';
import useCart from "@meepshop/hooks/lib/useCart";
import filter from '@meepshop/utils/lib/filter';
import { useRouter } from '@meepshop/link'; // graphql import

import { useCartFragment } from '@meepshop/hooks/lib/gqls/useCart';
import { getCart, useInitialCartFragment } from "../gqls/useInitialCart"; // definition

var useInitialCart = function useInitialCart() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mergingCart = _useState2[0],
      setMergingCart = _useState2[1];

  var _useApolloNetworkStat = useApolloNetworkStatus(),
      numPendingQueries = _useApolloNetworkStat.numPendingQueries;

  var _useQuery = useQuery(getCart),
      data = _useQuery.data,
      client = _useQuery.client;

  var router = useRouter();
  var query = router.query,
      asPath = router.asPath;

  var _useCart = useCart(useMemo(function () {
    return filter(useCartFragment, (data === null || data === void 0 ? void 0 : data.viewer) || null);
  }, [data])),
      cartItems = _useCart.cartItems,
      upsertCart = _useCart.upsertCart,
      mergeCart = _useCart.mergeCart;

  useEffect(function () {
    var _data$viewer;

    if (!mergingCart && (data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.role) === 'SHOPPER' && numPendingQueries === 0 && ((data === null || data === void 0 ? void 0 : data.viewer.guestCart.cartItems) || []).length !== 0) {
      setMergingCart(true);

      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return upsertCart(cartItems);

              case 2:
                setMergingCart(false);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, [data, cartItems, mergingCart, upsertCart, numPendingQueries]); // 處理 query 參數

  useEffect(function () {
    if (query.amounts && query.products && query.resetCart && query.variants) {
      var amounts = query.amounts,
          products = query.products,
          resetCart = query.resetCart,
          variants = query.variants;

      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var upsertCartItem, mergeUpsert;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!JSON.parse(resetCart)) {
                  _context2.next = 6;
                  break;
                }

                upsertCartItem = products.split(',').map(function (productId, index) {
                  return {
                    __typename: 'CartItem',
                    productId: productId,
                    quantity: parseInt(amounts.split(',')[index], 10),
                    variantId: variants.split(',')[index]
                  };
                });
                _context2.next = 4;
                return upsertCart(upsertCartItem);

              case 4:
                _context2.next = 9;
                break;

              case 6:
                mergeUpsert = products.split(',').reduce(function (result, productId, index) {
                  return _toConsumableArray(mergeCart(result, {
                    __typename: 'CartItem',
                    productId: productId,
                    quantity: parseInt(amounts.split(',')[index], 10),
                    variantId: variants.split(',')[index]
                  }));
                }, cartItems);
                _context2.next = 9;
                return upsertCart(mergeUpsert);

              case 9:
                router.push(asPath.split('?')[0]);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  useEffect(function () {
    var _data$viewer2, _data$viewer3;

    client.writeFragment({
      id: (data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : _data$viewer2.id) || null
      /* SHOULD_NOT_BE_NULL */
      ,
      fragment: useInitialCartFragment,
      fragmentName: 'useInitialCartFragment',
      data: {
        __typename: 'User',
        id: (data === null || data === void 0 ? void 0 : (_data$viewer3 = data.viewer) === null || _data$viewer3 === void 0 ? void 0 : _data$viewer3.id) || null
        /* SHOULD_NOT_BE_NULL */
        ,
        guestCart: {
          __typename: 'GuestCart',
          cartItems: JSON.parse(localStorage.getItem('guestCart') || '[]')
        }
      }
    });
  }, [data, client]);
};

export default useInitialCart;